import { PRODUCT_VARIANT_TEMPLATE_IDS } from '../constants/TemplateIds';

const ROOT_ITEM_NAMES = ['sitecore', 'content'];
const NORMALIZED_PRODUCT_VARIANT_TEMPLATE_IDS = new Set(
  PRODUCT_VARIANT_TEMPLATE_IDS.map((templateId) => templateId.toLowerCase())
);

const normalizeTemplateId = (templateId) => templateId?.replace(/[{}]/g, '').toLowerCase();

const createBreadcrumbItem = (item) => ({
  name: item.name,
  pageTitle: item.pageTitle?.value?.trim() || item.name,
  url: item.url,
});

export const buildBreadcrumbItems = (item) => {
  const parent = item?.parent;

  if (!parent || ROOT_ITEM_NAMES.includes(parent.name?.toLowerCase())) {
    return [];
  }

  return [...buildBreadcrumbItems(parent), createBreadcrumbItem(parent)];
};

export const getBreadcrumbLabel = (item, index, currentTemplateId) => {
  if (index === 0) {
    return item.name;
  }

  const usePageTitle = NORMALIZED_PRODUCT_VARIANT_TEMPLATE_IDS.has(
    normalizeTemplateId(currentTemplateId)
  );

  return usePageTitle ? item.pageTitle : item.name;
};
